import { useState, useCallback } from 'react';
import { toast } from 'sonner';

type AsyncActionOptions = {
  showErrorToast?: boolean;
  errorToastMessage?: string;
};

export function useAsyncAction(options: AsyncActionOptions = {}) {
  const { showErrorToast = true, errorToastMessage = 'common.error' } = options;
  const [isLoading, setIsLoading] = useState(false);

  const execute = useCallback(async <T>(
    action: () => Promise<T>,
  ): Promise<T | undefined> => {
    setIsLoading(true);
    try {
      return await action();
    } catch (error) {
      if (showErrorToast) {
        toast.error(errorToastMessage);
      }
      console.error('Async action failed:', error);
      return undefined;
    } finally {
      setIsLoading(false);
    }
  }, [showErrorToast, errorToastMessage]);

  return { isLoading, execute };
}
